import React, { Component } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Modal, TextArea, Notification, TextInput} from 'carbon-components-react';
import { Player, ControlBar, ReplayControl } from 'video-react';
import ReactAudioPlayer from 'react-audio-player';
import FileUploader from 'carbon-components-react/lib/components/FileUploader';
import Checkbox from 'carbon-components-react/lib/components/Checkbox';
import ImageZoom from 'react-medium-image-zoom';
import { Administrador, Consultor, Criacao, Interno, Supervisor } from '../../../config/UserStatusLevel';
import { Breadcrumb } from '../../index';
import { getByDmService, insertDmService, deleteDmService } from '../../../services/Api';
import appConfig from '../../../config/app-config';
import { forceDownload } from '../../../lib/validations';
import { Criacao as StatusCriacao, RevisaoInterna, Supervisao, AprovacaoDeArte, FechamentoDeArquivo, Redatora, Devolvido, AprovacaoDeRedacao, } from '../../../config/StatusPedido';
import Loading from '../../Loading';

const { IMAGE_PATHV2, IMAGE_PATH, API_URL } = appConfig;

class AgencyRequestsAdminArte extends Component {
  constructor(props) {
    super(props)
    this.state = {
      arrSelecionados: [],
      arrImgSelecionadas: [],
      loadUpload: false,
      openMdReprova: false,
      motivoReprova: '',
       isUrlModalOpen: false, // Controla se o modal de URL está aberto
       urlInput: '',          // Armazena o valor do input da URL
    }
  }

  componentWillMount = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    this.setState({ nivel: (user.nivel || {}).id });
    await this.load();
  }

  load = async () => {
    try {
      const { match } = this.props;
      const user = JSON.parse(localStorage.getItem('user'));
      const nivel = (user.nivel || {}).id;

      const pedido = await getByDmService('/Pedido/GetAgenciaAtendente', match.params.idPedido);
      const data = await getByDmService('/Arte/GetByItem', match.params.id);

      if (nivel !== Administrador && data && data.artes && data.artes.length > 0 && pedido.statusId > RevisaoInterna && pedido.statusAnteriorId !== Redatora) {
        data.artes = data.artes.filter(p => p.aprovada === true);
      }

      this.setState({ data, pedido, idStatus: pedido.statusId, idStatusAnterior: pedido.statusAnteriorId });
    } catch (error) {
      console.error(error);
    }
  }

  aprovar = async () => {
    const { arrSelecionados, data, idStatus, idStatusAnterior } = this.state;
    const { history } = this.props
    try {
      if (arrSelecionados.length === 0) {
        toast.warn("Selecione algo");
        return;
      }
      let obj = { "LstIdArte": arrSelecionados, "isRedatora": idStatusAnterior === Redatora };

      if (idStatus === RevisaoInterna) {
        obj.Aprovada = true;
      }
      if (idStatus === Supervisao) {
        obj.AprovadaSupervisao = true;
      }
      if (idStatus === AprovacaoDeArte) {
        obj.Aprovada2 = true;
      }

      if (idStatus === AprovacaoDeRedacao) {
        obj.AprovadaRedacao = true;
      }
     

      let result = await insertDmService('/Arte/Aprovacao', obj);

      // inicio - envia as artes que não foram aprovadas, para registro no banco e avanço de estagio do pedido.
      obj = { "LstIdArte": data.artes.filter(f => arrSelecionados.indexOf(f.id) === -1).map(p => p.id) };

     
      if (idStatus === Supervisao) {
        obj.AprovadaSupervisao = false;
      }
      if (idStatus === AprovacaoDeArte) {
        obj.Aprovada2 = false;
      }

      if (idStatus === AprovacaoDeRedacao) {
        obj.AprovadaRedacao = false;
      }

      if (obj.LstIdArte.length > 0)
        result = await insertDmService('/Arte/Aprovacao', obj);
      // fim

      if (result.startsWith('Pedido')) {
        toast.success(result);
        history.goBack()
      }
      else
        toast.success("Itens aprovados com sucesso");
      history.goBack()

    } catch (e) {
      this.errorHandler(e);
    }
  }

  // NOVOS MÉTODOS PARA O MODAL DE URL
 openUrlModal = () => {
   this.setState({ isUrlModalOpen: true, urlInput: '' }); // Limpa o input ao abrir
 };

 closeUrlModal = () => {
   this.setState({ isUrlModalOpen: false, urlInput: '' }); // Limpa e fecha o modal
 };

 handleUrlInputChange = (e) => {
   this.setState({ urlInput: e.target.value });
 };

 saveUrlFromModal = async () => {
   const { urlInput } = this.state;
   const { match } = this.props; // Obter o id do pedido da URL

   if (!urlInput || urlInput.trim() === '') {
     toast.warn('Por favor, insira uma URL válida.');
     return;
   }

   // Validação básica de URL no lado do cliente
   if (!urlInput.startsWith('http://') && !urlInput.startsWith('https://')) {
     toast.warn('A URL deve começar com "http://" ou "https://".');
     return;
   }

   try {
     this.setState({ loadUpload: true }); // Usar o estado de loading existente para feedback

     // Objeto a ser enviado para o backend
     const obj = {
       id: parseInt(match.params.id, 10), // ID do item do pedido
       Imagem: urlInput // A URL propriamente dita
     };

     // Chamar o serviço para salvar a URL.
     // Esta chamada assumirá que existe um novo endpoint no C# como /Arte/SaveUrl
     // que aceita um JSON body com os dados acima.
     await insertDmService(`/Arte/SaveUrl`, obj);

     toast.success('URL adicionada com sucesso!');
     this.closeUrlModal(); // Fechar o modal após sucesso
     await this.load(); // Recarregar os dados para exibir a nova URL
   } catch (error) {
     console.error('Erro ao adicionar URL:', error);
     this.errorHandler(error); // Usar seu método de tratamento de erro existente
   } finally {
     this.setState({ loadUpload: false }); // Finalizar o loading
   }
 };

 // FUNÇÃO AUXILIAR PARA DETERMINAR O SRC CORRETO NA RENDERIZAÇÃO
 // Isso é crucial para que URLs externas não sejam prefixadas com IMAGE_PATH
 getRenderSource = (file) => {
   if (file.startsWith('http://') || file.startsWith('https://')) {
     return file; // Se já é uma URL completa, use-a diretamente
   }
   // Caso contrário, é um caminho de arquivo local, prefixe com IMAGE_PATH
   return IMAGE_PATH + file;
 }

  showModalReprovacao = () => {
    this.setState(prevState => ({
      openMdReprova: !prevState.openMdReprova
    }))
  }

  reprovar = async () => {
    const { data, idStatus, pedido, motivoReprova, uploads, idStatusAnterior } = this.state;
    const { history, match } = this.props;
    const statusShowModal = [RevisaoInterna, AprovacaoDeArte, AprovacaoDeRedacao];

    try {
      const obj = {
        "LstIdArte": data.artes.map(p => p.id),
        "isRedatora": idStatusAnterior === Redatora,
        motivoReprova: (uploads && uploads.length > 0) ? `${motivoReprova} (com anexo)` : motivoReprova
      };

      if (!motivoReprova) {
        toast.warn("Informe o motivo da reprovação");
        return;
      }
      if (idStatus === RevisaoInterna) {
        obj.Aprovada = false;
      }
      if (idStatus === Supervisao) {
        obj.AprovadaSupervisao = false;
      }
      if (idStatus === AprovacaoDeArte) {
        obj.Aprovada2 = false;
      }
      if (idStatus === AprovacaoDeRedacao) {
        obj.AprovadaRedacao = false;
      }


      const result = await insertDmService('/Arte/Aprovacao', obj);
      if (statusShowModal.includes(pedido.statusId)) {
        await this.showModalReprovacao();
      }

      if (uploads) {
        await Promise.all(
          uploads.map(async file => {
            try {
              const D = new FormData();
              D.append('file', file);
              await insertDmService(`/Pedido/UploadArquivoReferencia/?IdItemPedido=${match.params.id}`, D);
            } catch (err) {
              toast.error(`Falha ao fazer upload: ${err.message}`);
            }
          }),
        );
      }

      if (result.startsWith('Pedido')) {
        toast.success(result);
        history.goBack()
      }
      else
        toast.success("Itens reprovados com sucesso");
      history.goBack()

    } catch (e) {
      if (statusShowModal.includes(pedido.statusId)) {
        await this.showModalReprovacao();
      }
      this.errorHandler(e);
    }
  }

  deleteImage = async (id) => {
    try {
      await deleteDmService('/Arte/', id);
      toast.success("Itens excluído com sucesso");
      this.load();
    } catch (e) {
      this.errorHandler(e);
    }
  }

  goUrl = () => {
    const { history, match } = this.props;
    const urlGo = `/admin/agencia/pedido/${match.params.idPedido}`;
    history.push(urlGo);
  };

  fileChangeRef = async (e, name) => {
    console.log("fileChange", e);
    const { match } = this.props;
    const { files } = document.getElementsByName(name)[0];
    if (files.length > 0) {
      const _files = [];
      for (let i = 0; i < files.length; i++) {
        if (files[i].size < 20000000) {
          _files.push(files[i]);
        }
        else {
          this.errorHandler(name);
        }
      }

      if (_files.length > 0) {
        await this.uploadFileArray(_files, match.params.id);
        setTimeout(async () => {
          await this.load();
        }, 750);
      }

      this.fileUploader.clearFiles();
    }
  };

  fileChange = async (name) => {
    const { files } = document.getElementsByName(name)[0];
    await this.setState(prevState => {
      const uploads = prevState.uploads || [];
      for (let i = 0; i < files.length; i++) uploads.push(files[i]);
      return { ...prevState, uploads };
    });
  }

  removeUpload = async (index, id) => {
    try {
      if (id)
        await deleteDmService('/Pedido/DeleteArquivoReferencia', [id]);
      await this.setState(prevState => {
        const newList = [...prevState.uploads];
        newList.splice(index, 1);
        return { uploads: newList };
      });
    } catch (error) {
      toast.error("Ocorreu uma falha ao excluir o arquivo");
    }
  }

  uploadFileArray = async (files, id) => {
    files.map(async file => {
      try {
        const data = new FormData();
        data.append('file', file);
        console.log("uploadFileArray", file)
        if (file.size >= 100000001) {
          toast.warn("O tamanho do arquivo excede o permitido");
        } else {
          this.setState({ loadUpload: true });
          await insertDmService(`/Arte/Upload/?IdItemPedido=${id}`, data);
          await this.setState({ loadUpload: false });
        }
      } catch (err) {
        this.setState({ loadUpload: false });
        toast.error(err.message);
      } finally {
        document.location.reload(true);
      }
    });
  };

  checkItem = (item, e) => {
    const { arrSelecionados, arrImgSelecionadas } = this.state;
    const idx = arrSelecionados.indexOf(item.id);
    const idxImg = arrImgSelecionadas.indexOf(item.imagem);
    if (idx > -1 && !e)
      arrSelecionados.splice(idx, 1);
    if (idx === -1 && e)
      arrSelecionados.push(item.id);
    if (idxImg > -1 && !e)
      arrImgSelecionadas.splice(idx, 1);
    if (idxImg === -1 && e)
      arrImgSelecionadas.push(item.imagem);
    this.setState({ arrSelecionados, arrImgSelecionadas })
  }

  verifyExtension = (file) => {


    const regex = /^.*?(https?:\/\/.+)$/;
    const match = file.match(regex);
    
    if (match && match.length > 1) {
      return "url";
    }

 //   console.log("verifyExtension", file); 
    if (file.startsWith('http://') || file.startsWith('https://')) {
   
        return "url"; // Indica que é uma URL externa
     }

    const ext = file.lastIndexOf(".");
    const currentExtension = file.substring(ext);
    const docs = ['.docx', '.doc', '.ppt', '.pptx', '.pdf', '.cdr', '.ai', '.xls', '.xlsx', '.psd'];
    const isImagem = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    const audio = ['.mp3'];
    const video = ['.mp4'];

    if (docs.includes(currentExtension)) {
      return "documento"
    }

    if (isImagem.includes(currentExtension)) {
      return "imagem"
    }

    if (audio.includes(currentExtension)) {
      return "audio"
    }

    if (video.includes(currentExtension)) {
      return "video"
    }

    return null;
  }

  errorHandler = err => {
    if (err === 'imagens') {
      toast.error('Ocorreu um erro ao salvar os dados, limite de tamanho de imagem a 20MB para cada imagem.');
    }
    if (err.error && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    }
    if (err.message)
      toast.error(err.message);
    else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  onChangeText = (event) => {
    const { target } = event;
    this.setState({
      [target.id]: target.value
    });
  }

 forceDownloadAsync = async (img) => {
    console.log("String original (img):", img);

    const regex = /^.*?(https?:\/\/.+)$/;
    const match = img.match(regex);

    let finalResourcePath = img; // Valor padrão, caso não encontre uma URL http

    if (match && match.length > 1) {
        // Se a regex encontrou uma correspondência e capturou a URL,
        // o grupo de captura 1 (match[1]) conterá a URL limpa.
        const [, url] = match;
        finalResourcePath = url; 
        console.log("URL externa extraída:", finalResourcePath);
    } else {
        console.log("Nenhuma URL externa (http/https) encontrada. Usando a string original como caminho de arquivo.");
    }

    // Agora, usamos finalResourcePath para a nossa lógica de decisão
    if (finalResourcePath.startsWith('http://') || finalResourcePath.startsWith('https://')) {
        console.log(`Detected as external URL: ${finalResourcePath}. Opening directly.`);
        window.open(finalResourcePath, '_blank', 'noopener,noreferrer');
        return; // Encerra a função
    }

    // Se chegou aqui, finalResourcePath é tratado como um caminho de arquivo local
    console.log(`Detected as local file path: ${finalResourcePath}. Proceeding with forced download.`);

    const LINK = document.createElement('a');
    
    // Seu código de download de arquivo local
    // Aqui, 'finalResourcePath' já deve ser o nome ou caminho relativo do arquivo.
    const encodedFileName = encodeURIComponent(finalResourcePath);
    const finalUrl = `${API_URL}/Dashboard/forcedownload?file=${encodedFileName}`;
    
    LINK.href = finalUrl;
    const evt = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': false
    });
    LINK.setAttribute('href', LINK.href);
    LINK.setAttribute('download', '');
    LINK.setAttribute('target', '_blank');
    LINK.dispatchEvent(evt);
};


  downloadFiles = async () => {
    const { arrImgSelecionadas } = this.state;
    let url = '';
    for (let i = 0; i < arrImgSelecionadas.length; i++) {
      const LINK = document.createElement('a');
      url = IMAGE_PATH + arrImgSelecionadas[i];
      const finalUrl = `${API_URL}/Dashboard/forcedownload?file=${encodeURIComponent(url.replace(IMAGE_PATH, ""))}`;

      LINK.href = finalUrl;
      const evt = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': false
      });

      LINK.setAttribute('href', LINK.href);
      LINK.setAttribute('download', '');
      LINK.setAttribute('target', '_blank');
      LINK.dispatchEvent(evt);
    };
  };

  selectAllFiles = async () => {
    const { data, arrSelecionados, arrImgSelecionadas } = this.state;
    arrSelecionados.length = 0;
    arrImgSelecionadas.length = 0;
    for (let i = 0; i < data.artes.length; i++) {
      const item = data.artes[i];
      arrSelecionados.push(item.id);
      arrImgSelecionadas.push(item.imagem);
    }
    this.setState({ arrSelecionados, arrImgSelecionadas })
  }

  downloadSelectedFiles = async () => {
    const { arrSelecionados } = this.state;
    const LINK = document.createElement('a');
    const finalUrl = `${appConfig.API_URL}/Arte/Download/${encodeURIComponent(arrSelecionados.join(';'))}`;

    LINK.href = finalUrl;
    const evt = new MouseEvent('click', {
      'view': window,
      'bubbles': true,
      'cancelable': false
    });

    LINK.setAttribute('href', LINK.href);
    LINK.setAttribute('download', '');
    LINK.setAttribute('target', '_blank');
    LINK.dispatchEvent(evt);
  }

  render() {
    const { history } = this.props;
    const userValues = JSON.parse(localStorage.getItem("user"));
    const { agencia } = userValues;
    const { pedido, data, nivel, idStatus, arrSelecionados, loadUpload, openMdReprova, motivoReprova, uploads, isUrlModalOpen, urlInput } = this.state;
    const { numero, unidade, dataSolicitacao, solicitante } = pedido || { numero: "--", unidade: "--", dataSolicitacao: "--", solicitante: "--" };
    const { nome: nomeSolicitante } = solicitante || {};

    return (
      <div className="">
        {loadUpload && (
          <Loading text="Carregando..." />
        )}
        <Breadcrumb
          title={`${numero} - ${unidade}`}
          description={(
            <div>
              Solicitado em
              &nbsp;
              <strong>{moment(dataSolicitacao).format("DD/MM/YYYY")}</strong>
              &nbsp;por&nbsp;
              <strong>{nomeSolicitante}</strong>
            </div>
          )}
          renderLeft={(
            <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          )}

          // && data.excluido === false
          renderRight={(
            <div className="criacao-upload">
              {(
                (((nivel === Administrador && agencia && [FechamentoDeArquivo].indexOf(pedido && pedido.statusId) > -1) ||
                (nivel === Administrador && [RevisaoInterna].indexOf(pedido && pedido.statusId) > -1)) 
                // && (userValues.nome === 'Lucas' || userValues.nome === 'Beatriz' || userValues.nome === 'Martha' || userValues.nome === 'Talita' || userValues.nome === 'Supervisão' || userValues.nome === 'Tamires')
                 ) ||
                (nivel === Administrador && [Supervisao].indexOf(pedido && pedido.statusId) > -1) ||
                ((nivel === Administrador || nivel === Interno) && [Devolvido].indexOf(pedido && pedido.statusId) > -1) ||
                ((nivel !== Criacao) && [AprovacaoDeRedacao].indexOf(pedido && pedido.statusId) > -1) ||
                (nivel !== Criacao && [AprovacaoDeArte].indexOf(pedido && pedido.statusId) > -1)
              ) && (
                <React.Fragment>
                  <button
                    className="bx--btn btn-primary-outlined h-sm-margin"
                    type="button"
                    disabled={!data || !data.artes || data.artes.length === 0 || data.artes.length === arrSelecionados.length}
                    onClick={async () => { await this.selectAllFiles() }}
                  >
                      Selecionar Todos os Arquivos
                  </button>
                  <button
                    className="bx--btn btn-secondary-outlined h-sm-margin"
                    type="button"
                    disabled={!data || !data.artes || data.artes.length === 0 || arrSelecionados.length === 0}
                    onClick={async () => { await this.downloadSelectedFiles() }}
                  >
                      Baixar Arquivo(s) Selecionado(s)
                  </button>
            


                    {[RevisaoInterna, AprovacaoDeArte, Supervisao].includes(pedido.statusId) ? (
                      <button
                        className="bx--btn btn-primary-outlined h-sm-margin"
                        type="button"
                        disabled={!(data && data.artes.length > 0 && data.excluido === false)}
                        onClick={() => this.showModalReprovacao()}
                      >
                        Reprovar Todos
                      </button>
                    ) : (
                      <button
                        className="bx--btn btn-primary-outlined h-sm-margin"
                        type="button"
                        disabled={!(data && data.artes.length > 0 && data.excluido === false)}
                        onClick={() => this.reprovar()}
                      >
                        Reprovar Todos
                      </button>
                    )}

                    {[RevisaoInterna, AprovacaoDeArte, Supervisao].includes(pedido.statusId) && data.excluido === false ? (
                      <button
                        className="bx--btn btn-success-color h-sm-margin"
                        type="button"
                        disabled={!(arrSelecionados && arrSelecionados.length > 0)}
                        onClick={async () => { await this.aprovar() }}
                      >
                        Aprovar selecionados
                      </button>
                    ) : (
                      ""
                    )}
                    {[AprovacaoDeRedacao].includes(pedido.statusId)  && data.excluido === false  ? (
                      <button
                        className="bx--btn btn-success-color h-sm-margin"
                        type="button"
                        disabled={!(arrSelecionados && arrSelecionados.length > 0)}
                        onClick={async () => { await this.aprovar() }}
                      >
                        Aprovar Redação selecionados
                      </button>
                    ) : (
                      ""
                    )}


                </React.Fragment>
                )}
                
              {[Criacao, Administrador].includes(nivel) && (idStatus === Redatora)  && data.excluido === false  && (
                <React.Fragment>
                  <button
                    className="bx--btn bx--btn--secondary h-sm-margin"
                    type="button"
                    onClick={this.openUrlModal}
                  >
                    Adicionar URL Externa
                  </button>
                </React.Fragment>
              )}

              {[Criacao, Administrador].includes(nivel) && (idStatus === StatusCriacao || idStatus === Redatora)  && data.excluido === false  && (
                <React.Fragment>
                  <FileUploader
                    className="upload-sem-p"
                    buttonLabel="Upload de imagens"
                    filenameStatus="edit"
                    onChange={async e => {
                      await this.fileChangeRef(e, 'imagens');
                    }}
                    buttonKind="secondary"
                    multiple
                    ref={fileUploaderRef => (this.fileUploaderRef = fileUploaderRef)}
                    accept={['.gif', '.jpeg', '.jpg', '.png', '.mp4', '.mp3', '.docx', '.doc', '.ppt', '.pptx', '.pdf', '.cdr', '.ai', '.xls', '.xlsx', '.psd', '.svg']}
                    name="imagens"
                  />
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Salvar
                  </button>
                </React.Fragment>
              )}
            </div>
          )}
        />
        <div className="content-wrapper">
          <div className="bx--row">
            <div className="bx--col-xs-12">
              <Notification
                kind="info"
                title="Extensões permitidas: "
                subtitle=".gif, .jpeg, .png, .mp4, .mp3, .docx, .doc, .ppt, .pptx, .pdf, .cdr, .ai, .xls, .xlsx, .psd, .svg"
              />
            </div>
          </div>
        </div>
        <div className="content-wrapper">
          {data && (<h3>{data.produto}</h3>)}
          {data && data.artes.length === 0 && (
            <p>Sem imagens até o momento</p>
          )}

          <div className="art-preview bx--row">
            {data && data.artes.map(item => (
             
              
              <div className={`art-preview-item ${ item.aprovada === true ? 'art-aprovada bx--col-md-4' : item.aprovada === false ? 'art-reprovada bx--col-md-2' : 'bx--col-md-3' }`} key={`i${item.id}`}>
                {this.verifyExtension(item.imagem) === "imagem" && (
                  <ImageZoom
                    image={{ src: IMAGE_PATH + item.imagem, }}
                    zoomImage={{ src: IMAGE_PATH + item.imagem, }}
                  />

                )}

                {this.verifyExtension(item.imagem) === "documento" && (
                  <div className="file-icon-dm">
                    <img
                      src={require('../../../assets/images/file_icon.png')}
                      alt="Download do Arquivo"
                    />
                  </div>
                )}

                {this.verifyExtension(item.imagem) === "url" && (
                  <div className="file-icon-dm">
                    <img
                      src={require('../../../assets/images/website.png')}
                      alt="Abrir Link"
                    />
                  </div>
                )}

                {this.verifyExtension(item.imagem) === "video" && (
                  <div className="file-video-dm">
                    <Player
                      autoPlay={false}
                      poster="/assets/poster.png"
                      startTime={0}
                      onerror={() => this.alert("erro")}
                      src={IMAGE_PATH + item.imagem}
                    >
                      <ControlBar autoHide={false}>
                        <ReplayControl seconds={15} order={2.1} />
                      </ControlBar>
                    </Player>
                  </div>
                )}

                {this.verifyExtension(item.imagem) === "audio" && (
                  <div className="file-audio-dm">
                    <ReactAudioPlayer
                      src={IMAGE_PATH + item.imagem}
                      autoPlay={false}
                      controls
                    />
                  </div>
                )}
                <span
                  className="text-center download-arte"
                  title="Documento"
                  rel="noopener noreferrer"
                  style={{ cursor: "pointer" }}
                  // onClick={() => {
                  //   forceDownload(appConfig.IMAGE_PATH + item.imagem, true)
                  //   setTimeout(() => {
                  //     document.location.reload(true);
                  //   }, 1000);
                  // }}
                  onClick={async () => { await this.forceDownloadAsync(item.imagem) }}

                >
                  Baixar Arquivo
                </span>

                <span>
                  {item.dataUpload && ("Data Upload: ")}
                  {item.dataUpload && (
                    <strong>{item.dataUpload ? moment(item.dataUpload).format('DD/MM/YYYY [às] HH:mm') : ''}</strong>
                  )}
                </span>

                {[Administrador, Criacao].indexOf(nivel) === -1 && (
                  <div className="status-item">
                    {([AprovacaoDeArte, FechamentoDeArquivo].indexOf(pedido.statusId) === -1 ? item.aprovada : item.aprovada2) && (
                      <i className="pointer trash-size material-icons">check_circle</i>
                    )}
                    {([AprovacaoDeArte, FechamentoDeArquivo].indexOf(pedido.statusId) === -1 ? item.aprovada : item.aprovada2) === false && (
                      <i style={{ color: "red" }} className="pointer trash-size material-icons">block</i>
                    )}
                  </div>
                )}
                <div className="img-action">
                  {[Administrador, Criacao, Interno].includes(nivel) && (idStatus === StatusCriacao || idStatus === Redatora) && (
                    <i className="pointer trash-size material-icons" onClick={() => this.deleteImage(item.id)}>
                      remove_circle
                    </i>
                  )}
                  {(([Supervisor, Consultor, Interno].indexOf(nivel) > -1 && [AprovacaoDeArte].indexOf(pedido.statusId) > -1) ||
                    ((nivel === Administrador || nivel === Interno) && [RevisaoInterna, AprovacaoDeArte, AprovacaoDeRedacao, FechamentoDeArquivo, Supervisao].indexOf(pedido.statusId) > -1)) && (
                      <React.Fragment>
                        <Checkbox labelText="" id={`id${item.id}`} checked={arrSelecionados.indexOf(item.id) > -1} onChange={(e) => { this.checkItem(item, e) }} />
                      </React.Fragment>
                    )}
                </div>
                {[Administrador, Criacao].indexOf(nivel) > -1 && (
                  <React.Fragment>
                    <div className="row-item">
                      {item.aprovada !== null && (
                        <div style={{ color: item.aprovada ? "green" : "red" }}>
                          <i className="pointer trash-size material-icons" onClick={() => this.deleteImage(item.id)}>
                            {item.aprovada ? "check_circle" : "block"}
                          </i>
                          {/* Revisão interna */}
                          {`Revisão: ${item.aprovadaPor}`}
                        </div>
                      )}
                      {item.aprovada === null && (<div>&nbsp;</div>)}
                    </div>
                    <div className="row-item">
                      {item.aprovadaSupervisao !== null && (
                        <div style={{ color: item.aprovadaSupervisao ? "green" : "red" }}>
                          <i className="pointer trash-size material-icons" onClick={() => this.deleteImage(item.id)}>
                            {item.aprovadaSupervisao ? "check_circle" : "block"}
                          </i>
                          {`Supervisão: ${item.aprovadaSupervisaoPor}`}
                        </div>
                      )}
                      {item.aprovadaSupervisao === null && (<div>&nbsp;</div>)}
                    </div>
                    <div className="row-item">
                      {item.aprovadaRedacao !== null && (
                        <div style={{ color: item.aprovadaRedacao ? "green" : "red" }}>
                          <i className="pointer trash-size material-icons" onClick={() => this.deleteImage(item.id)}>
                            {item.aprovadaRedacao ? "check_circle" : "block"}
                          </i>
                          {`Aprovação de redação: ${item.aprovadaRedacaoPor}`}
                        </div>
                      )}
                      {item.aprovadaRedacao === null && (<div>&nbsp;</div>)}
                    </div>
                    <div className="row-item">
                      {item.aprovada2 !== null && (
                        <div style={{ color: item.aprovada2 ? "green" : "red" }}>
                          <i className="pointer trash-size material-icons" onClick={() => this.deleteImage(item.id)}>
                            {item.aprovada2 ? "check_circle" : "block"}
                          </i>
                          {`Aprovação de arte: ${item.aprovada2Por}`}
                        </div>
                      )}
                      {item.aprovada2 === null && (<div>&nbsp;</div>)}
                    </div>
                  </React.Fragment>
                )}
              </div>
            ))}
          </div>
        </div>
        <Modal
          className="modalRepArte modal-avaliacao"
          open={openMdReprova}
          onRequestSubmit={() => this.reprovar()}
          onRequestClose={() => this.showModalReprovacao()}
          modalHeading="Escreva o motivo da reprovação de arte."
          primaryButtonText="Reprovar"
          secondaryButtonText="Cancelar"
        >
          <div className="bx--row">
            <div className="bx--col-md-12 bx--col-xs-12">
              <TextArea
                labelText=""
                id="motivoReprova"
                value={motivoReprova}
                onChange={e => this.onChangeText(e)}
                placeholder="Digite aqui o motivo"
              />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-md-12 bx--col-xs-12">
              <FileUploader
                id="reference"
                className="upload-referecy-agency"
                labelDescription=""
                buttonLabel="Adicionar referência"
                filenameStatus="edit"
                onChange={() => {
                  this.fileChange("reference");
                }}
                kind="secondary"
                ref={fileUploader => (this.fileUploader = fileUploader)}
                accept={['.jpg', '.png', '.gif', '.jpeg', '.bmp', '.mp3', '.mp4', '.wmv', '.pdf', '.docx', '.doc', '.pptx', '.ppt', '.psd', '.ai', '.cdr', '.xls', '.xlsx', '.eps', '.svg']}
                name="reference"
              />
              <div className="all-file-container">
                {uploads && uploads.length > 0 && uploads.map((item, index) => (
                  <div key={index} className="bx--file-container ">
                    <span className="bx--file__selected-file" id="reference" kind="secondary">
                      <a
                        rel="noopener noreferrer"
                        style={{ cursor: "pointer" }}
                        onClick={() => { forceDownload(IMAGE_PATHV2 + item.name) }}
                        alt="Uploads"
                      >
                        {item.name}
                      </a>
                      <i
                        className="item-upload-close pointer"
                        onClick={() => this.removeUpload(index, item.id)}
                      >
                        close
                      </i>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal>
        {/* NOVO MODAL PARA ADICIONAR URL EXTERNA */}
        <Modal
          open={isUrlModalOpen}
          onRequestClose={this.closeUrlModal}
          onRequestSubmit={this.saveUrlFromModal}
          modalHeading="Adicionar URL Externa"
          primaryButtonText="Salvar URL"
          secondaryButtonText="Cancelar"
        >
          <TextInput
            id="urlInput"
            labelText="URL"
            placeholder="Ex: https://www.exemplo.com/recurso"
            value={urlInput}
            onChange={this.handleUrlInputChange}
            light // Estilo light do Carbon
            autoComplete="off" // Desativa o autocomplete do navegador
            // pattern="^https?://.+$" // Validação HTML5 básica (opcional, o JS já valida)
            // invalid={!!urlValidationMessage} // Exemplo de uso para erro do Carbon
            // invalidText={urlValidationMessage} // Mensagem de erro
          />
        </Modal>
      </div>
    )
  }
}

export default AgencyRequestsAdminArte;



// WEBPACK FOOTER //
// ./src/components/agency/requests/Arts.js